import { UserRole } from '../types';

export const USER_ROLES: UserRole[] = ['admin', 'editor', 'user'] as const;
export const USER_ROLE_SCOPES = ['tenant', 'editor'] as const;

/**
 * Role hierarchy levels used for authorization.
 *
 * This is used for both:
 * - Page/route access control
 * - Store (key-value storage) read/write permissions
 *
 */
export const USER_ROLE_LEVEL: Record<UserRole, number> = {
  user: 1,
  editor: 2,
  admin: 3,
} as const;
